import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { formatApiError } from "../lib/api";
import { toast } from "sonner";
import BotQuickLink from "../components/BotQuickLink";
import PublicHeader from "../components/PublicHeader";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      const next = location.state?.from?.pathname || "/menu";
      navigate(next, { replace: true });
    } catch (err) {
      const msg = formatApiError(err);
      setError(msg);
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background bg-grain flex flex-col">
      <PublicHeader ctaTo="/register" ctaLabel="Registrati" />
      <div className="flex-1 flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="text-5xl mb-3">🍱</div>
          <h1 className="font-display text-3xl sm:text-4xl font-semibold tracking-tight mb-2">
            Schiscetta Ufficio
          </h1>
          <p className="text-sm text-muted-foreground">
            Il menu condiviso dei colleghi
          </p>
        </div>
        <div className="bg-card border border-border rounded-lg p-7 sm:p-8">
          <h2 className="font-display text-xl font-medium mb-5">Accedi</h2>
          <form onSubmit={onSubmit} className="space-y-4">
            <div>
              <label className="block text-sm font-medium mb-1.5">Email</label>
              <input
                type="email"
                required
                autoComplete="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                data-testid="login-email-input"
                className="w-full px-3 py-2.5 bg-white border border-border rounded-md focus:outline-none focus:ring-2 focus:ring-primary/40 focus:border-primary transition-colors"
              />
            </div>
            <div>
              <label className="block text-sm font-medium mb-1.5">Password</label>
              <input
                type="password"
                required
                autoComplete="current-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                data-testid="login-password-input"
                className="w-full px-3 py-2.5 bg-white border border-border rounded-md focus:outline-none focus:ring-2 focus:ring-primary/40 focus:border-primary transition-colors"
              />
            </div>
            {error && (
              <div className="text-sm text-accent bg-accent/5 border border-accent/20 rounded-md p-3" data-testid="login-error">
                {error}
              </div>
            )}
            <button
              type="submit"
              disabled={loading}
              data-testid="login-submit-button"
              className="w-full py-2.5 bg-primary text-white font-medium rounded-md hover:bg-[#436343] active:scale-[0.98] disabled:opacity-50 transition-all duration-200"
            >
              {loading ? "Accesso…" : "Entra"}
            </button>
          </form>
          <p className="text-center text-sm text-muted-foreground mt-6">
            Non hai un account?{" "}
            <Link to="/register" className="text-primary font-medium hover:underline" data-testid="link-register">
              Registrati
            </Link>
          </p>
          <p className="text-center text-xs text-muted-foreground mt-3">
            <Link to="/forgot-password" className="text-muted-foreground hover:text-primary hover:underline" data-testid="link-forgot-password">
              Password dimenticata?
            </Link>
          </p>
        </div>

        <div className="mt-5">
          <BotQuickLink variant="compact" />
        </div>

        <p className="text-center text-xs text-muted-foreground mt-6">
          Nuovo qui?{" "}
          <Link to="/info" className="text-primary hover:underline" data-testid="link-info">
            Scopri di cosa si tratta
          </Link>
        </p>
      </div>
      </div>
    </div>
  );
}
